/**
 * src/domains/jobs/useJobStore.ts
 *
 * React hook for marketplace jobs.
 * Uses useSyncExternalStore to subscribe to the job store.
 */
import { useSyncExternalStore } from 'react';

import { jobStore, loadJobs, loadMyJobs } from './jobs.store';

export function useJobStore() {
  const state = useSyncExternalStore(
    jobStore.subscribe,
    jobStore.getSnapshot,
  );

  return {
    ...state,
    loadJobs,
    loadMyJobs,
  };
}
